import vue from 'vue';
import toastComponent from './toast.vue';

const ToastConstructor = vue.extend(toastComponent);

function showToast({ text, type, duration, callback }) {
  const toastDom = new ToastConstructor({
    el: document.createElement('div'),
    data() {
      return {
        isShow: true, // 是否显示
        text, // 文本内容
        type: type || 'success', // 类型
      };
    },
  });
  // 添加节点
  document.body.appendChild(toastDom.$el);
  // 过渡时间
  setTimeout(() => {
    toastDom.isShow = false;
    if (callback) {
      callback();
    }
  }, duration || 2000);
}
// 全局注册
function registryToast() {
  vue.prototype.$toast = showToast;
}

export default registryToast;



// WEBPACK FOOTER //
// ./src/components/toast/toast.js